import { render } from "./PageLayoutNone.vue?vue&type=template&id=73a121c0"
import script from "./PageLayoutNone.vue?vue&type=script&lang=js"
export * from "./PageLayoutNone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__